import { Button, EyeFilled16, TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import { ControlWrapper } from '../../../../components/ControlWrapper';
import { useOfferContext } from '../../../../context';

export function HideOfferControlContainer() {
  const {
    api: { onHideOffer },
    isHideOfferInProgress,
  } = useOfferContext();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!isHideOfferInProgress) {
      onHideOffer();
    }
  };

  return (
    <ControlWrapper>
      <TooltipDesktop theme="black" placement="left" title="Скрыть">
        <Button
          data-mark="HideOfferControl"
          theme="stroke_secondary"
          onClick={handleClick}
          size="XS"
          loading={isHideOfferInProgress}
          beforeIcon={<EyeFilled16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
}
